<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <div class="body">
      <h1 class="t-inverse t-center">
        Logged Out
      </h1>

      <p class="t-inverse t-center">
        You have been logged out.
      </p>

      <div class="t-center">
        <router-link class="button button--inverse" to="/">Search Properties</router-link>
      </div>
    </div>
  </layout-fullscreen>
</template>

<script>
  import { mapState } from 'vuex';
  import LayoutFullscreen from '@/layouts/Fullscreen';

  export default {
    name: 'AccountLogout',

    components: {
      LayoutFullscreen
    },

    computed: {
      ...mapState([
        'user'
      ])
    },

    created () {
      window.localStorage.removeItem('token');

      if (this.user.authenticated) window.location.reload();
    }
  };
</script>